// libs
import { styled } from '@nykaa/ui-components';
import { BREAKPOINTS } from 'shared/styles/base';

export const PlpWrapper = styled.div`
  &&[data-at='listing-faq'] {
    width: 100%;
    max-width: none;
    margin: 0;
    padding: ${({ theme }) => theme.spacing.spacing0};
    ${({ theme }) => theme.typography.bodyLarge};
  }
`;

export const PlpSection = styled.div`
  margin: ${({ theme }) => `${theme.spacing.spacing160} 0`};
`;

export const PlpSectionTitle = styled.h3`
  ${({ theme }) => theme.typography.titleSmall};
  font-weight: 700;
  margin: 0 0 ${({ theme }) => theme.spacing.spacing50} 0;
  color: ${({ theme }) => theme.colors.textSecondary};
`;

export const FaqList = styled.div`
  padding: ${({ theme }) => theme.spacing.spacing0};
`;

export const FaqItem = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.spacing100};
  color: ${({ theme }) => theme.colors.textSecondary};
  &:last-child {
    margin-bottom: ${({ theme }) => theme.spacing.spacing0};
  }
`;

export const FaqQuestion = styled.span`
  display: block;
  margin-bottom: ${({ theme }) => theme.spacing.spacing20};
  ${({ theme }) => theme.typography.bodyMedium};
  font-weight: 700;
  @media (max-width: ${BREAKPOINTS.DESKTOP}px) {
    ${({ theme }) => theme.typography.bodyMedium};
    font-weight: 700;
  }
`;

export const FaqAnswer = styled.p`
  margin: ${({ theme }) => theme.spacing.spacing0};
  ${({ theme }) => theme.typography.bodyMedium};
`;
